eval("define(\'window\',[], function() {\n    return this;\n});\n\n//# sourceURL=/window.js");

